define(['edge/platform/base/BaseCtrl', 'text!../views/mfp-uw-issues.html', 'angular'], (BaseCtrl, uwIssueTemplate, angular) => {


    const fn = function ($scope, LoadSaveService, CustomQuoteService, MFPService, ModalService, DefaultErrorHandlerService) { // NOSONAR

        const ctrl = Object.create(BaseCtrl);

        ctrl.init = function () {
        };


        ctrl.createAndQuoteSubmission = function () {
            let savePromise, 
quotePromise;

            // Conditionally create or save a submission
            if (!$scope.quoteandbind.submission.quoteID) {
                savePromise = LoadSaveService.createSubmission('quoteandbind', $scope.quoteandbind.submission);
                savePromise.then((draftSubmission) => {

                    quotePromise = LoadSaveService.saveAndQuoteSubmission('quoteandbind', draftSubmission);
                    quotePromise.then((quotedSubmission) => {
                        if (!handleUwIssues(quotedSubmission)) {
                            $scope.setModel(quotedSubmission); //setModel only, when you are sure you can proceed with it
                            $scope.goToNext();
                        }
                    }, (error) => {
                        DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
                    });

                    //no more waiting popup - ModalService.showProgressDialog('quoteandbind.controllers.mpfWizardController.Updating your quote...', quotePromise);

                }, (error) => {
                    DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
                });
            } else {
                quotePromise = LoadSaveService.saveAndQuoteSubmission('quoteandbind', $scope.quoteandbind.submission);
                quotePromise.then((quotedSubmission) => {
                    if (!handleUwIssues(quotedSubmission)) {
                        $scope.setModel(quotedSubmission);
                        $scope.goToNext();
                    }
                }, (error) => {
                    DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
                });
                //no more waiting popup - var waitingMessage = 'quoteandbind.controllers.WizardFlowCtrl.Saving...';
                //no more waiting popup - ModalService.showProgressDialog(waitingMessage, quotePromise);
            }
        };

        /**
         * checks if there is an underwritig issue and if there is one it will be displayed in a popup
         *
         * @param quotedSubmission
         * @returns {boolean}
         */
        function handleUwIssues(quotedSubmission) {
            const uwIssues = quotedSubmission.uWIssues;

            if (!uwIssues) {

                return false;

            }

                uwIssues.forEach((uwIssue) => {

                    const data = {
                        code: uwIssue.code,
                        desc: uwIssue.longDescription,
                    };
                    const functions = {

                    };
                    ModalService.showSimpleDialog(uwIssueTemplate, data, functions);
                });
                return true;
            
        }
        

        ctrl.editQuotedSubmissionAndRequote = function () {

            //UI DEFECT WORKAROUND: UI validates OK non-Required, Size-12chars field with value '' (empty string),
            //however backend Invalidates request/crash. Value must be NULL.
            if ($scope.quoteandbind.submission.draftData.accountHolder.contact.isCompany && $scope.quoteandbind.submission.draftData.accountHolder.contact.uid === '') {
                $scope.quoteandbind.submission.draftData.accountHolder.contact.uid = null;
            }

            let saveAndRequotePromise;
            saveAndRequotePromise = LoadSaveService.editQuotedSubmissionAndRequote('quoteandbind', $scope.quoteandbind.submission);
            saveAndRequotePromise.then((quotedSubmission) => {

                if (!handleUwIssues(quotedSubmission)) {
                    $scope.setModel(quotedSubmission);
                    $scope.goToNext();
                }

            }, (error) => {
                DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
            });

            //no more waiting popup - var waitingMessage = 'quoteandbind.controllers.WizardFlowCtrl.Saving...';
            //no more waiting popup - ModalService.showProgressDialog(waitingMessage, saveAndRequotePromise);

        };

        ctrl.reload = function (retrieveDTO) {
            let retrieveSubmissionPromise = LoadSaveService.retrieveSubmission('quoteandbind', retrieveDTO);
            retrieveSubmissionPromise = retrieveSubmissionPromise.then((quotedSubmission) => {
                $scope.setModel(quotedSubmission);
            }, (error) => {
                if (error.isRetriable) {
                    //note: cannot recover to consistent situation, customer need to change language again
                    ModalService.showError('platform.basler.DefaultErrorHandlerService.Retriable Error',
                        'platform.basler.DefaultErrorHandlerService.Retriable Offer Translation Error.Please retry');
                    error.handled = true;
                }
            });
            return retrieveSubmissionPromise;
        };

        ctrl.requoteAndBindSubmission = function () {

            //save non persistent data here
            const proofOfInsurance = angular.copy($scope.quoteandbind.submission.bindData.proofOfInsuranceQuestions);

            const saveAndRequotePromise = LoadSaveService.editQuotedSubmissionAndRequote('quoteandbind', $scope.quoteandbind.submission);
            saveAndRequotePromise.then((quotedSubmission) => {

                if (!handleUwIssues(quotedSubmission)) {
                    //restore data between backend calls
                    quotedSubmission.bindData.proofOfInsuranceQuestions = proofOfInsurance;

                    const bindPromise = LoadSaveService.bindSubmission('quoteandbind', quotedSubmission);
                    bindPromise.then((quotedSubmission) => {
                        $scope.setModel(quotedSubmission);
                        $scope.goToNext();
                    }, (error) => {
                        DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
                    });
                }

            }, (error) => {
                DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
            });
            //no more waiting popup - var waitingMessage = 'quoteandbind.controllers.WizardFlowCtrl.Saving...';
            //no more waiting popup - ModalService.showProgressDialog(waitingMessage, saveAndRequotePromise);


        };        

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'qnb.LoadSaveService', 'qnb.CustomQuoteService', 'MFPService', 'ModalService', 'DefaultErrorHandlerService'];

    return fn;

});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/controllers/MFPWizardCtrl.js